import { Table } from "react-bootstrap";
import "../scss/tableComponent.scss";
import { format } from "date-fns";
import { COLUMN_TYPE, DATE_FORMAT } from "../consts";
import NoDataFound from './noDataFound';


const TableComponent = ({ columns, data, title, actionClick }) => {
  const getValue = (obj, path) => {
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };
  return (
    <div className="table-container">
      {title && <h2 className="label-title">{title}</h2>}
      {data?.length === 0 ? (
          <NoDataFound text = "No data found"/>
        ): (
      <Table striped bordered hover responsive className="custom-table">
        <thead>
          <tr>
            {columns?.map((col) => (
              <th key={col.accessor}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns?.map((col) => {
                let rawValue = col.value ||getValue(row, col.accessor);  
                let cellValue = col.render ? col.render(row) : rawValue;
                if (col.type === "date") {
                  cellValue = cellValue
                    ? format(new Date(cellValue), DATE_FORMAT.DD_MM_YYYY)
                    : col.defaultValue ? col.defaultValue : "--";
                } if (col.type ===  COLUMN_TYPE.dateTime && cellValue) {
                  cellValue = cellValue
                    ? format(new Date(cellValue), DATE_FORMAT.DD_MM_YYYY_HH_MM)
                    : col.defaultValue ? col.defaultValue :  "--";
                } else {
                  cellValue = (cellValue!= undefined || cellValue!= null) ? String(cellValue) :col.defaultValue ? col.defaultValue :  "--";
                }
                const handleClick = actionClick && col.action 
                  ? (e) => {
                      e.stopPropagation();
                      actionClick(row, rowIndex, col.action);
                    }
                  : undefined;

                return (
                  <td
                    key={col.accessor}
                    className={col.className}
                    style={col.style}
                    onClick={handleClick}
                    role={col.action ? "button" : undefined}
                    tabIndex={col.action ? 0 : undefined}
                  >
                    {cellValue}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </Table>)}
    </div>
  );
};

export default TableComponent;